import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicPagesComponent } from '../pages/public-pages/public-pages.component';
import { publicPagesRoutes } from '../pages/public-pages/public-pages-routes';
import { ROUTE_PATH } from './RoutePath.const';
import { AuthProcessPagesComponent } from '../pages/auth-process-pages/auth-process-pages.component';
import { authProcessPagesRoutes } from '../pages/auth-process-pages/auth-process-pages-routes';
import { FeedbackProcessPagesComponent } from '../pages/feedback-process-pages/feedback-process-pages.component';
import { feedbackProcessPagesRoutes } from '../pages/feedback-process-pages/feedback-process-pages-routes';
import { PrivatePagesComponent } from '../pages/private-pages/private-pages.component';
import { privatePagesRoutes } from '../pages/private-pages/private-pages-routes';
import { AuthGuard } from './auth.guard';
import { redirectLinkPagesRoutes } from '../pages/redirect-link-pages/redirect-link-pages-routes';
import { RedirectLinkPagesComponent } from '../pages/redirect-link-pages/redirect-link-pages.component';
import { PreventInIframeGuard } from './prevent-in-iframe.guard';

const routes: Routes = [
  {
    path: ROUTE_PATH.AUTH_PROCESS,
    component: AuthProcessPagesComponent,
    children: authProcessPagesRoutes,
  },
  {
    path: ROUTE_PATH.REDIRECT_LINK,
    component: RedirectLinkPagesComponent,
    children: redirectLinkPagesRoutes,
  },
  {
    path: ROUTE_PATH.FEEDBACK_PROCESS,
    component: FeedbackProcessPagesComponent,
    children: feedbackProcessPagesRoutes,
    canActivate: [PreventInIframeGuard],
  },
  {
    path: ROUTE_PATH.PRIVATE,
    component: PrivatePagesComponent,
    children: privatePagesRoutes,
    canActivate: [AuthGuard],
  },
  { path: '', component: PublicPagesComponent, children: publicPagesRoutes },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
